import React from 'react';
import { Logo } from '../layout/Logo';

interface AgeGateProps {
  onConfirm: (isAdult: boolean) => void;
}

export function AgeGate({ onConfirm }: AgeGateProps) {
  const handleConfirm = (isAdult: boolean) => {
    onConfirm(isAdult);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background p-4">
      <div className="w-full max-w-md rounded-xl bg-surface p-8 shadow-2xl">
        <div className="mb-6 flex justify-center">
          <Logo />
        </div>

        <h2 className="mb-4 text-center text-2xl font-bold text-on-surface">
          Before We Begin
        </h2>

        <p className="mb-6 text-center text-sm text-on-surface-variant">
          This platform contains medical information about extended fasting protocols. It is
          designed for adults only.
        </p>

        <p className="mb-4 text-center text-sm text-on-surface">
          By continuing, you acknowledge that 222fasting is a wellness tool and not a substitute for professional medical advice. If you feel your relationship with food is becoming a struggle beyond these protocols, please reach out for support: Eating Disorders South Africa: <a href="tel:0827625090" className="text-on-surface font-semibold">082 762 5090</a>.
        </p>

        <div className="flex flex-col gap-3">
          <button
            onClick={() => handleConfirm(true)}
            className="w-full rounded-lg bg-primary px-4 py-3 font-medium text-primary-contrast hover:bg-primary-hover"
          >
            I am 18 or older
          </button>
          <button
            onClick={() => handleConfirm(false)}
            className="w-full rounded-lg bg-surface px-4 py-3 font-medium text-on-surface hover:bg-on-surface/10"
          >
            I am under 18
          </button>
        </div>

      </div>
    </div>
  );
}
